
import React from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './quehacemos5ecyb.scss';






const Pquehacemos5ecyb = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  
  
  

  
  return (
    <div id="id6898f0f78e5aed52dc7b55a3" >

      <div id="ibm6" className="">
      
      <div id="iwqt" className="">
      
      <div id="incm3" className="">
      
        <a
          target=""
          className=""
          id="ixtof"
          href="/"
        >
          
      <img
        className=""
        id="iwbnr"
        src="https://assetsprojects.s3.amazonaws.com/404pziime609rgd.png"
        alt="undefined"
      />
      
        </a>
        
      <div id="id16m" className="">
      
        <a
          target=""
          className="link-menu "
          id="ikbb5"
          href="/"
        >
          
    <div id="i5zvy" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="iaz2n"
          href="/informacion"
        >
          
    <div id="igsoz" className="">
    <>Nuestra información</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu link-activo "
          id="ijoly"
          href="/quehacemos"
        >
          
    <div id="i1fz4" className="">
    <>Que Hacemos</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="i6wju"
          href="/guiadigital"
        >
          
    <div id="iu68s" className="">
    <>Guía Digital</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="iqw23"
          href="/contacto"
        >
          
    <div id="i97f5" className="">
    <>Contacto</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="i6utf"
          href="https://hackathon.sustentahonduras.org/"
        >
          
    <div id="i5bxh" className="">
    <>Hackathon</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i2zb" className="">
      
      <div
        id="iqf8z"
        className=""
        data-aos="fade-down"
        data-aos-duration="1200"
      >
      
      <div id="izgm8" className="">
      
      <div id="ix4ee" className="">
      
      <div className="" id="iqji1">
        <>Que Hacemos</>
      </div>
      
      <div id="iru8i" className="">
      
      <img
        className=""
        id="i6g22"
        src="https://assetsprojects.s3.amazonaws.com/404pziime62kiqn.png"
        alt="undefined"
      />
      
      <div className="" id="i9tfg">
        <>Ofrecemos información clara y sencilla sobre el proceso electoral, desde cómo registrarte hasta cómo votar correctamente.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="i2ef2" className="">
      
      <img
        className=""
        id="i59dy"
        src="https://assetsprojects.s3.amazonaws.com/404pziime62kiqn.png"
        alt="undefined"
      />
      
      <div className="" id="i2clb">
        <>Creamos campañas y actividades que inspiran a los jóvenes a participar activamente en la democracia.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="i2e7u" className="">
      
      <img
        className=""
        id="if6e9"
        src="https://assetsprojects.s3.amazonaws.com/404pziime62kiqn.png"
        alt="undefined"
      />
      
      <div className="" id="ipmsl">
        <>Brindamos guías, recursos y asistencia para que cada voto se emita de manera informada y segura.</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="it9wf" className="">
      
      <img
        className=""
        id="ifsrx"
        src="https://assetsprojects.s3.amazonaws.com/404pziime62oal3.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iss5" className="">
      
      <div id="izyl6q" className="">
      
      <div className="" id="iwoln1">
        <>Todos los Derechos Reservadost © 2025 Jovenes al Voto</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pquehacemos5ecyb);
  